import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=70e34292&scoped=true&"
import script from "./Investment.vue?vue&type=script&lang=js&"
export * from "./Investment.vue?vue&type=script&lang=js&"
import style0 from "./Investment.vue?vue&type=style&index=0&id=70e34292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e34292",
  null
  
)

export default component.exports